<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import InvoiceService from '@/services/invoice';

export default {
  page: {
    title: "Curva ABC de Clientes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Curva ABC de Clientes",
      loading: false,
      abcCurve: [],
      searchParams: {
        customer: '',
      },
      searchEmptyField: false,
      totalLast: 0,
      totalCurrent: 0,
      
      filter: '',
      filterOn: [],
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 50,

      fields: [
        { key: 'code', sortable: true, label: 'Código' },
        { key: 'name', sortable: true, label: 'Razão Social' },
        { key: 'group', sortable: true, label: 'Grupo' },
        { key: 'totalLast', sortable: true, label: 'R$ Mês Anterior', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'totalCurrent', sortable: true, label: 'R$ Mês Atual', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'actions', label: '' },
      ],

      itemsFields: [
        { key: 'code', sortable: true, label: 'Código' },
        { key: 'description', sortable: true, label: 'Produto' },
        { key: 'totalLast', sortable: true, label: 'R$ Mês Anterior', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'totalCurrent', sortable: true, label: 'R$ Mês Atual', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
      ]
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    rows() {
      return this.abcCurve.length;
    },
    startIndex() {
      return (this.currentPage * this.perPage) - this.perPage + 1;
    },
    endIndex() {
      const endIndex = (this.currentPage * this.perPage);
      if (this.abcCurve.length < endIndex) {
        return this.abcCurve.length;
      }

      return endIndex;
    }
  },
  methods: {
    search() {
      this.searchEmptyField = false;
      this.load();
    },
    load() {
      this.loading = true;

      InvoiceService.getAbcCurveCustomers(this.searchParams.customer).then(res => {
        this.loading = false;

        this.abcCurve = res.data.data;
        this.totalLast = res.data.totalLast;
        this.totalCurrent = res.data.totalCurrent;
      }).catch(() => {
        this.loading = false;
      })
    },
    exportData() {
      this.loading = true;

      InvoiceService.exportAbcCurveCustomers(this.searchParams.customer).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'CurvaABC_Clientes.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    },
    changeSearch() {
      if (this.searchParams.customer === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.load();
      }
    },
    details(row) {
      if (row.item._showDetails) {
        return row.item._showDetails = false;
      }

      this.abcCurve.forEach((item) => {
        this.$set(item, '_showDetails', false)
      })

      row.toggleDetails();

      if (!row.item.items) {
        row.item.loadingDetails = true;

        InvoiceService.getAbcCurveCustomersDetails(row.item._id).then(res => {
          row.item.items = res.data;
          row.item.loadingDetails = false;
          this.$forceUpdate();
        }).catch(() => {
          row.item.loadingDetails = false;
          this.$forceUpdate();
        })
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Busca</label>
                    <input
                      type="text"
                      v-model="searchParams.customer"
                      v-on:keyup="changeSearch"
                      class="form-control"
                      placeholder="Razão Social ou Código do Cliente"
                    />
                  </div>
                </div>
              </div>

              <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="abcCurve"
                :fields="fields"
                responsive="sm"
                head-variant="light"
                :per-page="perPage"
                :current-page="currentPage"
              >
                <template v-slot:cell(actions)="row">
                  <a href="javascript:void(0);" class="action-icon text-success mr-3" @click="details(row)">
                    <i class="mdi mdi-eye font-size-18"></i>
                  </a>
                </template>

                <template v-slot:row-details="row">
                  <div class="loading-center" v-if="row.item.loadingDetails">
                    <b-spinner size="sm" variant="primary" role="status"></b-spinner>
                  </div>

                  <b-table
                    bordered
                    small
                    :items="row.item.items"
                    :fields="itemsFields"
                    responsive="sm"
                    v-if="!row.item.loadingDetails"
                  >
                  </b-table>
                </template>

                <template slot="bottom-row">
                  <td colspan="1"></td>
                  <td class="text-left nowrap-col">
                    <strong>Valor Total:</strong>
                  </td>
                  <td class="text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalLast | currency}}</h4>
                  </td>
                  <td class="text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalCurrent | currency}}</h4>
                  </td>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{rows}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
  .button-search {
    display: flex;
    align-items: center;
  }

  .nowrap-col {
    white-space: nowrap;
  }

  .customer-detail {
    .field {
      display: flex;
      flex-direction: row;

      p {
        margin-bottom: 8px;

        &.title {
          font-weight: 600;
          color: #000;
          margin-right: 16px;
        }
      }
    }
  }

  .loading-center {
    justify-content: center;
    display: flex;
  }
</style>